export default __webpack_public_path__ + "static/media/Nousha.9675ed20.png";